import { connect } from "react-redux";
import { LocationInput as Component, LocationInputProps } from "./LocationInput.component";
import { RootState } from "../../../../reducers";
import { clearCustomAddress, setCustomAddress } from "../../actions";

const mapStateToProps = (state: RootState) => ({});

export const LocationInput = connect(mapStateToProps, {
  onClearCustomLocation: clearCustomAddress,
  onCustomLocationSelection: setCustomAddress,
} as Pick<LocationInputProps, "onClearCustomLocation" | "onCustomLocationSelection">)(Component);
